import React, { useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouteComponentProps } from "react-router-dom";
import CustomerWorkOrderResult from "../CustomerWorkOrderResult";
import { useDispatch } from "react-redux";
import { userChosenBackValue } from "../../ducks/redux/actions/userChoices";
import { Helper } from "../../utils/Helper/HelperUtil";

interface AssetWorkOrderResultProps extends RouteComponentProps<any> {
}

 
const AssetWorkOrderResult: React.FC<AssetWorkOrderResultProps> = (props) => {
const dispatch = useDispatch();

useEffect(() => {
    dispatch(userChosenBackValue(Helper.BackValue.AssetWorkOrderResult));
}, [dispatch]);

    return (
        <CustomerWorkOrderResult {...props} isVisibleForAsset={true} />)
}

export default AssetWorkOrderResult;